import { LogoutButton } from '@/components/buttons';
import { ContentPanel } from '@/components/content-panel';
import { PrimaryLayout } from '@/layouts/primary';
import { TopNavFor } from '@/layouts/primary/top-nav';
import { Alert, Text } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import { useMemo } from 'react';

export const BillingPage = () => {
	const logoutButton = useMemo(() => <LogoutButton />, []);

	return (
		<PrimaryLayout
			header={{ title: 'Account', backTo: '/account', children: logoutButton }}
			topNav={TopNavFor.ACCOUNT}
		>
			<ContentPanel gap="md">
				<Alert icon={<IconInfoCircle />} variant="filled" bg="blue.0" mb="md">
					<Text size="sm">
						This page is currently under construction. Please check back soon for updates.
					</Text>
					<Text size="sm">Thank you for your patience.</Text>
				</Alert>
			</ContentPanel>
		</PrimaryLayout>
	);
};
